import { splitHdnValue } from "@/helpers/hdnHelpers";
import type { Ref } from "vue";
import { computed } from "vue";
import type { Row } from "@rocicorp/zero";
import { useQuery } from "./useZero";
import { queries } from "@loanlink-nl/zero";

export type LenderRecord = Row["lender"];

export function useLenderProducts(selectedLenderCode: Ref<string | undefined>) {
	const { data: products } = useQuery(() =>
		queries.products.forProvider({
			providerCode: selectedLenderCode.value ?? "",
		}),
	);

	const productOptions = computed(() => {
		if (!selectedLenderCode.value || !products.value) {
			return [];
		}

		return products.value
			.map((product) => ({
				value: product.productCode,
				label: splitHdnValue(product.productCode)[1],
			}))
			.toSorted((a, b) => a.label.localeCompare(b.label));
	});

	function getProductOption(productCode: string) {
		return productOptions.value.find((option) => option.value === productCode);
	}

	return { productOptions, getProductOption };
}
